import React, { useState } from "react";
import { Form, Input, Button, Card, Select, message, Typography } from "antd";
import axiosInstance from "../api/axiosInstance";
import { UserOutlined, LockOutlined, ProfileOutlined } from "@ant-design/icons";
import "./login.css";

const { Option } = Select;
const { Title, Text } = Typography;

const Register = ({ onCancel }) => {
  const [loading, setLoading] = useState(false);

  const onRegister = async (values) => {
    setLoading(true);
    try {
      await axiosInstance.post("/auth/register", values);
      message.success("Registrasi berhasil! Silakan login.");
      onCancel();
    } catch (error) {
      message.error(error.response?.data?.message || "Registrasi gagal");
    }
    setLoading(false);
  };

  return (
    <Card className="login-card">
      <img
        src="https://images.crunchbase.com/image/upload/c_pad,f_auto,q_auto:eco,dpr_1/v1397185652/9a3a585523122dc6c0728459e9a71da0.png"
        alt="Logo"
        style={{ width: 130 }}
      />

      <Title level={3} style={{ marginBottom: 10, color: "#003399" }}>
        <span style={{ fontWeight: "bold" }}>DAILY MEETING APPS</span>
      </Title>
      <Text type="secondary">
        Silahkan Daftar untuk menggunakan aplikasi ini
      </Text>

      <Form onFinish={onRegister} layout="vertical" style={{ marginTop: 20 }}>
        <Form.Item
          name="nama_user"
          rules={[{ required: true, message: "Masukkan username" }]}
        >
          <Input
            size="large"
            placeholder="Nama Pengguna"
            prefix={<UserOutlined />}
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: "Masukkan password" }]}
        >
          <Input.Password
            size="large"
            placeholder="Password"
            prefix={<LockOutlined />}
          />
        </Form.Item>
        <Form.Item
          name="jabatan_user"
          rules={[{ required: true, message: "Masukkan jabatan" }]}
        >
          <Input
            size="large"
            placeholder=" Jabatan"
            prefix={<ProfileOutlined />}
          />
        </Form.Item>
        <Form.Item
          name="id_role"
          rules={[{ required: true, message: "Pilih role" }]}
        >
          <Select size="large" placeholder="Pilih Role">
            <Option key="1" value="1">
              Kepala Seksi
            </Option>
            <Option key="2" value="2">
              Project Manager
            </Option>
            <Option key="3" value="3">
              Sistem Analyst
            </Option>
            <Option key="4" value="4">
              Programmer
            </Option>
            <Option key="5" value="5">
              Quality Control
            </Option>
            <Option key="6" value="6">
              Quality Assurance
            </Option>
          </Select>
        </Form.Item>
        <div className="button-group">
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
          >
            Daftar
          </Button>
          &nbsp;
          <Button
            type="default"
            size="large"
            className="btn-cancel"
            onClick={onCancel}
          >
            Batal
          </Button>
        </div>
      </Form>
      <div style={{ textAlign: "center", width: "100%", marginTop: "20px" }}>
        <Text strong style={{ color: "grey" }}>
          © {new Date().getFullYear()} DM APPS - Daily Meeting Management System
        </Text>
        <br />
        <Text strong style={{ color: "grey" }}>
          Created with ❤️ by Anak Tangga
        </Text>
      </div>
    </Card>
  );
};

export default Register;
